import * as React from 'react';

import { pure } from 'recompose';

import { SvgIcon } from '@coursera/coursera-ui';
import type { Svg } from '@coursera/coursera-ui/svg';

const SvgAdvancedLevelComponent: Svg = ({ title = 'Advanced', ...props }) => (
  <SvgIcon title={title} {...props} viewBox="0 0 48 48" fill="none">
    <g id="Advanced">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7825 15V46H14.6086V30H4.17384V43.9058L4.17383 45L4.17384 46H43.826L43.826 45L43.826 43.9058V2H33.3912V46H29.2173V15H18.7825Z"
        id="SvgAdvanced"
      />
    </g>
  </SvgIcon>
);

const SvgAdvanced = pure(SvgAdvancedLevelComponent);
SvgAdvanced.displayName = 'SvgAdvanced';

export default SvgAdvanced;
